import React from "react";
import { colors } from "../../../themes/Colors";

const CheckInput = ({ label, selected, onClick }) => {
  return (
    <div
      style={{
        width: "100%",
        height: 25,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginLeft: 14,
          fontSize: 12,
          opacity: 0.8,
          fontWeight: "bold",
        }}
      >
        {label}
      </div>
      <div
        style={{
          height: "100%",
          width: 30,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          onClick={onClick}
          style={{
            height: 15,
            width: 15,
            borderRadius: 4,
            borderStyle: "solid",
            marginRight: 10,
            transition: "all 0.3s",
            backgroundColor: selected ? colors.greenDark : null,
            borderColor: selected ? colors.greenDark : colors.greenDark,
          }}
        ></div>
      </div>
    </div>
  );
};

export default CheckInput;
